// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-plus[data-v-2b6eeeaf] {\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
